import PedidoService from "@/services/PedidoService";

export const pedido = {
  namespaced: true,
  state: {
    pedido: {},
  },
  actions: {
    getPedido({ commit }, payload) {
      return PedidoService.GetPedido(payload).then(
        (pedido) => {
          return Promise.resolve(pedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedido({ commit }, payload) {
      return PedidoService.PostPedido(payload).then(
        (pedido) => {
          return Promise.resolve(pedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedido({ commit }, payload) {
      return PedidoService.PutPedido(payload).then(
        (pedido) => {
          return Promise.resolve(pedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedido({ commit }, payload) {
      return PedidoService.DeletePedido(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoOData({ commit }, payload) {
      return PedidoService.GetPedidoOData(payload).then(
        (pedido) => {
          return Promise.resolve(pedido);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    imprimirPedido({ commit }, payload) {
      return PedidoService.ImprimirPedido(payload).then(
        (pedido) => {
          return Promise.resolve(pedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default pedido;
